<template>
  <div class="sport">
    <div class="sportTitle">最新活动</div>
    <div class="sportEn">RECENT ACTIVITIES</div>
    <div class="sportBox">
      <img :src="nav.mobilePhoto" alt="" class="sportBoxImg" />
      <div class="sportBoxBottom">
        <div class="sportBoxTitle">{{ nav.title }}</div>
        <div class="sportBoxDetail">{{ nav.detail }}</div>
        <div class="sportBoxFooter">
          <div @click="jumpLink(nav.path)" class="sportBoxFooterInspect">查看详情</div>
          <Btn :navArr="arr" :style="styleBtn" @fetchNav="fetchNav" />
        </div>
      </div>
    </div>
    <img src="https://p5.ssl.qhimg.com/t110b9a93012011b1da8b277831.png" alt="" class="sportBg" />
  </div>
</template>

<script setup>
import Btn from '@/components/common/2024/header-btn.vue'

import { ref } from 'vue'
const styleBtn = {
  position: 'absolute',
  right: '0',
  bottom: '-9px'
}

const props = defineProps(['arr'])
const arr = props.arr || {}
let nav = ref(arr[0])
function fetchNav(newId) {
  nav.value = arr[newId]
}
const jumpLink = (url) => {
  if(url) {
    window.open(url, '_blank');
  }
}
</script>

<style lang="scss" scoped>
.sport {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 16px;
  }
  &Box {
    z-index: 20;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    border-radius: 32px;
    // height: 380px;
    &Img {
      width: 100%;
      border: 32px 32px 0 0;
    }
    &Bottom {
      padding: 16px 12px 22px;
    }
    &Title {
      font-family: Source Han Sans;
      font-size: 14px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
    }
    &Detail {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      text-align: justify; /* 浏览器可能不支持 */
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
      margin: 4px 0 16px;
      min-height: 66px;
    }
    &Footer {
      display: flex;
      justify-content: space-between;
      position: relative;
      &Inspect {
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-8 */
        color: #525966;
        border-radius: 8px;
        opacity: 1;
        box-sizing: border-box;
        border: 1px solid #e2e6ed;
        width: 79px;
        height: 32px;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  &Bg {
    position: absolute;
    bottom: 18px;
    right: 0;
    width: 74px;
  }
}
</style>
